import React from "react";

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  className?: string;
}

export const InputField = React.forwardRef<HTMLInputElement, InputFieldProps>(
  ({ error, className: _, maxLength, onChange, onBlur, className, ...props }, ref) => (
    <div
      className={`flex items-center h-12 px-4 rounded-[4px] border border-[#00000027] ${error ? "ring-1 ring-[#D73D1D]" : ""}`}
    >
      <input
        type="text"
        ref={ref}
        maxLength={maxLength}
        onChange={(e) => {
          if (maxLength && e.target.value.length > maxLength) {
            e.target.value = e.target.value.slice(0, maxLength);
          }
          onChange?.(e);
        }}
        onBlur={(e) => {
          const trimmed = e.target.value.trim();
          if (trimmed !== e.target.value) {
            e.target.value = trimmed;
            onChange?.(e as unknown as React.ChangeEvent<HTMLInputElement>);
          }
          onBlur?.(e);
        }}
        {...props}
        className={
          "w-full bg-transparent text-base leading-6 tracking-[-0.01em] text-black font-bold placeholder:font-normal disabled:text-[#BBBBBB] placeholder:text-[#B0B0B0] outline-none focus:outline-none focus:ring-0 [&:-webkit-autofill]:shadow-[0_0_0_30px_white_inset] [&:-webkit-autofill]:[-webkit-text-fill-color:black]" +
          ` ${className ?? ""}`
        }
      />
    </div>
  ),
);
